module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image-chap"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "70",
      "src": "images/common.jpg",
      "width": "85"
    }
  }), _vm._v(" Chapter 1")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("My brother is not your standard brother. Free is beautiful. I don’t mean he is cute in the way all little kids are cute, I mean he is gorgeous. He has blond, blond hair that curls around his face, and eyes a shade of gray green I’ve never seen on anyone else. Free has read since he was three, played piano since he was four. My friends Rachel and Elizabeth say their younger siblings are just pains in the butt, but I think Free is cool. We play Monopoly and cribbage and backgammon together, and he’s a wicked chess player. He laughs, he cries, and he hums, but he does not talk. Free is five. Mom and I talk to Free just like normal, and somehow we always know what’s on his mind. When people finally realize that he isn’t just supershy, they ask me why he doesn’t talk. I tell them the truth: I don’t know, and I don’t care.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("When we moved to this neighborhood a year ago, kids on the block called him a freak and yelled things ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("at him, as if he didn’t hear instead of speak. Those kids were a little surprised at how fast I was and how hard I could hit for a skinny girl. And if their parents called and complained, Mom made mincemeat of them real quick. Nobody messes with my mom. At least more than once.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("We had moved three times in five years and I was sick of it. Sick of being the new kid and just about finding someone I could be my real self with, and then boom! Mom would get a better job and move us someplace else. I’d tried crying and screaming at her, but Mom would just hold me and rock me and pat my back. “I have to do what I have to do,” she’d say. I guess we were all sick of it, because this time she’d promised we’d stay for at least five years. Pinkie-promised.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When they tested Free for kindergarten, they didn’t let him in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s not quite ready for us, I’m afraid, Mrs. LaMer,” the woman at the Early Education Service said, a little too sweetly, tapping Free’s folder with her inch-long blue fingernails.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("“You mean you’re not quite ready for him,” my mother said, just as sweetly, reaching over to tap the ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("folder with her own short, unpainted fingernails. She hates it when people call her “Mrs.”")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("So Free went to a private school, but he had to have a doctor’s letter before even they would take him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know what’s wrong with him,” Doctor Dan had said, “so what am I supposed to write in a letter?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("nothing")]), _vm._v(" wrong with him,” Mom said, “and you know it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look, Annalise, Freeman is a very bright child, even gifted, but he’s five years old and he is not verbal. That’s not normal,” Doctor Dan said. “I know you don’t want to, but perhaps it’s time to see a specialist.” He reached for a pad. My mother got there first and pushed it out of his reach.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Normal?” Mom’s voice went up a notch. “He reads at the fifth-grade level, and he plays chess better than most adults. That’s not normal either! Why don’t those things bother you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There are reasons for selective mutism,” Doctor Dan said. “None of them are good: autism, schizophrenia, trauma—”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("“I bet I’ve read more about selective mutism than you have,” Mom said. “He’s clearly not autistic, he hears fine, he shows no symptoms of schizophrenia, ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("and the only trauma he experiences is people insisting he should talk!”")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Doctor Dan closed his eyes and rested his forehead in one hand. I felt a little sorry for him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why must there be a label or a syndrome for every aspect of life? He’s just different.” Mom turned Free’s shirt right side out and started to pull it down over his head. “I like different. Different is good.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My brother’s knee knocked mine, and when I looked up, Free was smiling at me. It was a small smile, the one that says, “Way to go, Mom!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom hardly ever gets angry, at least with us, but that day I could see that she was afraid she might boil over and ruin Free’s chances at kindergarten by not getting that letter. I knew how she felt, because sometimes I feel like I’ve swallowed a tightly wound spring that’s going to cut loose—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("boing!")]), _vm._v("—any minute. If it did, I would start whirling and never stop, round and round, bouncing off walls forever. If I could loosen that spring somehow, just gain a little slack, then I could coast for a long, long time.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Free knew how my mom felt too. He went over, put his hand on Doctor Dan’s knee, and looked him in the eye. I know that face. Even people who can ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("deal with my mom are no match for my brother. Doctor Dan looked at my mother, then at me. I sent him thoughts as hard as I could. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Just write the stupid letter.")]), _vm._v(" Doctor Dan looked back at Free and sighed.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, have it your way. The letter will state that he’s perfectly healthy and there is no known etiology for his delayed speech.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom let go a small sigh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But, Annalise, you’re going to have to deal with this sooner rather than later. The world will bend for a silent five-year-old, but each year from here on out it will bend a little less.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’ll talk when he’s ready,” Mom said. “He’ll be just fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Outside Doctor Dan’s, we did a three-way high five.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "27",
      "src": "images/common2.jpg",
      "width": "30"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My mom isn’t much taller than I am, but she looks taller because she is so slender and muscular. She used to take us on camping trips and for long bike rides, and she taught us both how to ski and swim. When I was little, I used to tell my mother she was beautiful, but she only laughed.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("“All little girls think their mothers are beautiful,” she would say, and then she would kiss me. “And all ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("mothers know their little girls are beautiful, so it works out fine.”")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Her jeans are only a couple sizes bigger than mine, and the thin lines of gray in her light brown hair are the only way you can tell she isn’t just my older sister. When I suggest that she dye it, she just gives me one of her that’s-too-tacky-for-words looks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t have gray hair before I had children,” she’ll say, raising an eyebrow. She always raises that eyebrow when she’s thinking something she’s too polite to say. I don’t even think she knows that she does it. “I’m keeping my gray hair. I’ve earned every strand.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mom is really weird sometimes.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c62556b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 66
// module chunks = 0